import Main from '@/components/main'
import parentView from '@/components/parent-view'

/**
 * iview-admin中meta除了原生参数外可配置的参数:
 * meta: {
 *  hideInMenu: (false) 设为true后在左侧菜单不会显示该页面选项
 *  notCache: (false) 设为true后页面不会缓存
 *  access: (null) 可访问该页面的权限数组，当前路由设置的权限会影响子路由
 *  icon: (-) 该页面在左侧菜单、面包屑和标签导航处显示的图标，如果是自定义图标，需要在图标名称前加下划线'_'
 *  beforeCloseName: (-) 设置该字段，则在关闭当前tab页时会去'@/router/before-close.js'里寻找该字段名对应的方法，作为关闭前的钩子函数
 * }
 */

export default [
  {
    path: '/login',
    name: 'login',
    meta: {
      title: 'Login - 登录',
      hideInMenu: true
    },
    component: () => import('@/view/login/login.vue')
  },
  {
    path: '/',
    name: '_home',
    redirect: '/home',
    component: Main,
    meta: {
      hideInMenu: false,
      notCache: true
    },
    children: [
      {
        path: '/home',
        name: 'home',
        meta: {
          hideInMenu: false,
          title: '首页',
          notCache: true,
          icon: 'md-home'
        },
        component: () => import('@/view/single-page/home')
      },
      {
        path: '/signup',
        name: 'signup',
        meta: {
          title: '报名',
          hideInMenu: true,
        },
        component: () => import('@/view/biz/signup.vue')
      },
      {
        path: '/renew',
        name: 'renew',
        meta: {
          title: '续费',
          hideInMenu: true,
        },
        component: () => import('@/view/biz/renew.vue')
      }
    ]
  },
  {
    path: '/schedule',
    name: 'schedule',
    component: Main,
    meta: {
      title: '排课',
      access: ['PERM_EDU_PAGE_SCHEDULE']
    },
    children: [
      {
        path: 'index',
        name: 'schedule_index',
        meta: {
          icon: 'ios-calendar',
          title: '排课'
        },
        component: () => import('@/view/schedule/index.vue')
      }
    ]
  },
  {
    path: '/clazz',
    name: 'clazz',
    component: Main,
    meta: {
      title: '班级',
      access: ['PERM_EDU_PAGE_CLASS']
    },
    children: [
      {
        path: 'index',
        name: 'clazz_index',
        meta: {
          icon: 'ios-apps',
          title: '班级'
        },
        component: () => import('@/view/clazz/index.vue')
      },
      {
        path: 'detail',
        name: 'clazz_detail',
        meta: {
          title: '班级详情',
          hideInMenu: true,
        },
        component: () => import('@/view/clazz/detail.vue')
      }
    ]
  },
  {
    path: '/teacher',
    name: 'teacher',
    component: Main,
    meta: {
      title: '教师',
      access: ['PERM_EDU_PAGE_TEACHER']
    },
    children: [
      {
        path: 'index',
        name: 'teacher_index',
        meta: {
          icon: 'md-person',
          title: '教师'
        },
        component: () => import('@/view/teacher/teacher_index.vue')
      },
      {
        path: 'detail',
        name: 'teacher_detail',
        meta: {
          title: '教师',
          hideInMenu: true,
        },
        component: () => import('@/view/teacher/teacher_detail.vue')
      }
    ]
  },
  {
    path: '/student',
    name: 'student',
    component: Main,
    meta: {
      title: '学员',
      access: ['PERM_EDU_PAGE_STUDENT']
    },
    children: [
      {
        path: 'index',
        name: 'student_index',
        meta: {
          icon: 'ios-people',
          title: '学员',
        },
        component: () => import('@/view/student/student_index.vue')
      },
      {
        path: 'detail',
        name: 'student_detail',
        meta: {
          hideInMenu: true,
          title: '学生详情',
          notCache: true
        },
        component: () => import ('@/view/student/student_detail.vue')
      },
      // {
      //   path: 'addclass',
      //   name: 'addclass',
      //   meta: {
      //     title: '安排课程',
      //     hideInMenu: true,
      //   },
      //   component: () => import('@/view/student/addclass.vue')
      // }
    ]
  },
  {
    path: '/zone',
    name: 'zone',
    component: Main,
    meta: {
      title: '校区',
      access: ['PERM_EDU_PAGE_ZONE']
    },
    children: [
      {
        path: 'index',
        name: 'zone_index',
        meta: {
          icon: 'ios-podium',
          title: '校区'
        },
        component: () => import('@/view/zone/zone_index.vue')
      }
    ]
  },
  {
    path: '/course',
    name: 'course',
    component: Main,
    meta: {
      icon: 'ios-book',
      title: '课程',
      access: ['PERM_EDU_PAGE_COURSE']
    },
    children: [
      {
        path: 'cate',
        name: 'course_cate',
        meta: {
          title: '类别',
          access: ['PERM_EDU_PAGE_COURSE_CATE']
        },
        component: () => import('@/view/course/course_cate.vue')
      },
      {
        path: 'index',
        name: 'course_index',
        meta: {
          title: '课程',
          access: ['PERM_EDU_PAGE_COURSE_INDEX']
        },
        component: () => import('@/view/course/course_index.vue')
      }
    ]
  },
  {
    path: '/plugins',
    name: 'plugins',
    component: Main,
    meta: {
      title: '插件'
    },
    children: [
      {
        path: 'index',
        name: 'plugins_index',
        meta: {
          icon: 'ios-apps',
          title: '插件'
        },
        component: () => import('@/view/plugins/index.vue')
      }
    ]
  },
  {
    path: '/signup',
    name: 'signup',
    component: Main,
    meta: {
      title: '预约',
      access: ['PERM_EDU_PAGE_APPOINTMENT'],
      hideInMenu: true,
    },
    children: [
      {
        path: 'index',
        name: 'signup_index',
        meta: {
          icon: 'ios-alarm',
          title: '预约'
        },
        component: () => import('@/view/signup/signup.vue')
      }
    ]
  },
  {
    path: '/report',
    name: 'report',
    component: Main,
    meta: {
      icon: 'ios-book',
      title: '数据'
    },
    children: [
      {
        path: 'daily',
        name: 'report_daily',
        meta: {
          title: '日报'
        },
        component: () => import('@/view/report/daily.vue')
      },
      {
        path: 'class_hour',
        name: 'report_class_hour',
        meta: {
          title: '课时'
        },
        component: () => import('@/view/report/class_hour.vue')
      },
      {
        path: 'cancel_class',
        name: 'report_cancel_class',
        meta: {
          title: '请假统计'
        },
        component: () => import('@/view/report/cancel_class.vue')
      },
      {
        path: 'attendance',
        name: 'report_attendance',
        meta: {
          title: '出勤率'
        },
        component: () => import('@/view/report/attendance.vue')
      },
      {
        path: 'msg',
        name: 'class_msg',
        meta: {
          title: '留言信息'
        },
        component: () => import('@/view/report/msg.vue')
      }
    ]
  },
  {
    path: '/setting',
    name: 'setting',
    component: Main,
    meta: {
      icon: 'md-settings',
      title: '设置',
      access: ['PERM_EDU_PAGE_SYS']
    },
    children: [
      {
        path: 'user',
        name: 'setting_user',
        meta: {
          title: '用户',
          access: ['PERM_EDU_PAGE_SYS_USER']
        },
        component: () => import('@/view/setting/user/user.vue')

      },
      {
        path: 'role',
        name: 'setting_role',
        meta: {
          title: '角色',
          access: ['PERM_EDU_PAGE_SYS_ROLE']
        },
        component: () => import('@/view/setting/role/role.vue')

      },
      {
        path: 'notify',
        name: 'setting_notify',
        meta: {
          title: '通知',
          access: ['PERM_EDU_PAGE_SYS_NOTIFY']
        },
        component: () => import('@/view/setting/notify/notify.vue')
      },
      // {
      //     path: 'weixin',
      //     name: 'setting_weixin',
      //     meta: {
      //         title: '微信设置'
      //     },
      //     component: () => import('@/view/setting/weixin/weixin.vue')
      // },
      {
        path: 'time',
        name: 'setting_time',
        meta: {
          title: '时间段',
          access: ['PERM_EDU_PAGE_SYS_TIME']
        },
        component: () => import('@/view/setting/time/time_index.vue')
      },
      {
        path: 'vacation',
        name: 'setting_vacation',
        meta: {
          title: '假期',
          access: ['PERM_EDU_PAGE_SYS_HOLIDAY']
        },
        component: () => import('@/view/setting/vacation/vacation_index.vue')
      }
    ]
  },
  {
    path: '/other',
    name: '_other',
    component: Main,
    meta: {
      hideInMenu: true,
      notCache: true
    },
    children: [
      {
        path: '/present_hour',
        name: 'present_hour',
        meta: {
          hideInMenu: true,
          title: '赠送课时',
          notCache: true
        },
        component: () => import('@/view/present_hour/index')
      }
    ]
  }
]
